var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "btn btn--primary product-buy__cart-btn",
      on: {
        click: function ($event) {
          return _vm.addToCart()
        },
      },
    },
    [_vm._v(_vm._s(_vm.btnValueText))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }